<template>
  <div class="container">
	<div class="header-banner-container">
		<div class="header-container">
			<div class="left">
				<img alt="" src="../assets/cyxy/logo.png">
			</div>
			<span class="menus">
				<span class="menu-item" :class="curMenu === 1? 'active' : ''" @click="changeMenu(1)">首页</span>
				<span class="menu-item" :class="curMenu === 2? 'active' : ''" @click="changeMenu(2)">公司简介</span>
				<span class="menu-item" :class="curMenu === 3? 'active' : ''" @click="changeMenu(3)">产品中心</span>
				<span class="menu-item" :class="curMenu === 4? 'active' : ''" @click="changeMenu(4)">联系我们</span>
			</span>
		</div>
		<div class="banner-container">
			<div>
				<div class="title">
					医院信息系统
				</div>
				<div class="desc">
					医院信息系统（HIS），以医院操作人员为主体，主要帮助医院进行门诊挂号、门诊收费、病人入院管理、病人入出管理、病人预交管理、病人结账管理、病人费用查询、医技记账管理、执行登记管理、票据使用监控、收费财务监控、票据入库管理和人员借款管理。
				</div>
				<div class="more-btn" style="margin-top: 1.2rem">
					了解更多
				</div>
			</div>
			<img class="banner-icon" src="../assets/cyxy/img_banner.png" alt="">
		</div>
	</div>
	<div class="company-profile-container" id="company-profile-container">
		<div class="container-title">
			企业理念
		</div>
		<div class="idea-list">
			<div class="idea-list-item">
				<div class="white-block">
					<span class="label">企业愿景</span>
					<div class="desc">科技让医疗更简单</div>
				</div>
			</div>
			<div class="idea-list-item">
				<div class="white-block">
					<span class="label">企业使命</span>
					<div class="desc">打造新概念医疗信息管理系统</div>
				</div>
			</div>
			<div class="idea-list-item">
				<div class="white-block">
					<span class="label">企业价值观</span>
					<div class="desc">聚焦患者诊疗质量、提高医护协同效率、提升医院管理水平</div>
				</div>
			</div>
		</div>
		<div class="flex">
			<img class="company-pic" src="../assets/cyxy/img_company.jpg" alt="">
			<div class="left">
				<div class="title">企业简介</div>
				<div class="desc">
					创羽心研(苏州)技术有限公司，是一家专注于大数据技术在信息化领域深入应用的医疗信息化软件公司，核心业务是研发面向医疗机构的新一代基于医嘱为核心的医院信息管理系统（HIS）和临床诊疗智能辅助信息系统。自创立以来，企业业绩实现了跨越式发展，企业用户和研发能力持续增长，已获得近20项软件著作权，若干项发明专利申请中，是江苏省中小型科技企业。
				</div>
				<div class="more-about">
					更多关于公司
				</div>
			</div>
		</div>
	</div>
	<div class="product-list" id="product-list">
		<div class="product-list-title">产品中心</div>
		<div class="product-list-menu">
			<div class="item" :class="{'active': curProduct === 0}" @click="changeCurProduct(0)">
				<img :src="require('../assets/cyxy/btn_hospital' + (curProduct=== 0? '_s' : '_n') + '.png')" alt="">
				医院信息系统
			</div>
			<div class="item" :class="{'active': curProduct === 1}" @click="changeCurProduct(1)">
				<img :src="require('../assets/cyxy/btn_drug'+(curProduct=== 1? '_s' : '_n')+'.png')" alt="">
				医院药品信息管理系统
			</div>
			<div class="item" :class="{'active': curProduct === 2}" @click="changeCurProduct(2)">
				<img :src="require('../assets/cyxy/btn_monitor'+(curProduct=== 2? '_s' : '_n')+'.png')" alt="">
				重症监护临床信息系统
			</div>
			<div class="item" :class="{'active': curProduct === 3}" @click="changeCurProduct(3)">
				<img :src="require('../assets/cyxy/btn_diagnosis'+(curProduct=== 3? '_s' : '_n')+'.png')" alt="">
				重症辅诊临床信息系统
			</div>
		</div>
		<div class="" id="product-list-0">
			<div class="flex">
				<div class="left">
					<img src="../assets/cyxy/icon_hospital.png" alt="">
					<div class="title">医院信息系统</div>
					<div class="desc">
						医院信息系统（HIS），以医院操作人员为主体，主要帮助医院进行门诊挂号、门诊收费、病人入院管理、病人入出管理、病人预交管理、病人结账管理、病人费用查询、医技记账管理、执行登记管理、票据使用监控、收费财务监控、票据入库管理和人员借款管理。
					</div>
					<div class="more-btn">了解更多</div>
				</div>
				<img class="icon" src="../assets/cyxy/img_hospital.jpg" alt="">
			</div>
			<div class="line" />
		</div>
		<div class="" id="product-list-1">
			<div class="flex">
				<img class="icon-left" src="../assets/cyxy/img_drug.jpg" alt="">
				<div class="right">
					<img src="../assets/cyxy/icon_drug.png" alt="">
					<div class="title">医院药品信息管理系统</div>
					<div class="desc">
						帮助医院药品部门进行药品的出入库，采购，调价和盘点。让药品部门更好的进行对药品的监管，效期报警可以更好的提示药品的有效期，尽早对药品进行处理。方便查阅药品厂商信息、出入库历史、采购历史和调价历史。
					</div>
					<div class="more-btn">了解更多</div>
				</div>
			</div>
			<div class="line" />
		</div>
		<div class="" id="product-list-2">
			<div class="flex">
				<div class="left">
					<img src="../assets/cyxy/icon_monitor.png" alt="">
					<div class="title">重症监护临床信息系统</div>
					<div class="desc">
						重症监护信息系统实现病人体症（如心率、血压、体温、血氧）数据的自动采集、护理记录单的自动生成、以及病历的电子化，是医院信息系统的一个重要组成部分。
					</div>
					<div class="more-btn">了解更多</div>
				</div>
				<img class="icon" src="../assets/cyxy/img_monitor.jpg" alt="">
			</div>
			<div class="line" />
		</div>
		<div class="" id="product-list-3">
			<div class="flex">
				<img class="icon-left" src="../assets/cyxy/img_diagnosis.jpg" alt="">
				<div class="right">
					<img src="../assets/cyxy/icon_diagnosis.png" alt="">
					<div class="title">重症辅诊临床信息系统</div>
					<div class="desc">
						重症辅诊临床信息系统实现病人体征（如心率、血压、体温、血氧饱和度）和医嘱数据的分析利用、护理记录单的自动生成、以及重症病历的电子化，是医院信息系统的一个重要组成部分。
					</div>
					<div class="more-btn">了解更多</div>
				</div>
			</div>
		</div>
	</div>
	<div class="contact-us-container" id="contact-us-container">
		<div class="flex">
			<div class="info">
				<img class="icon" src="../assets/cyxy/logo.png" alt="">
				<div class="menus">
					<span class="menu-item" :class="curMenu === 1? 'active' : ''" @click="changeMenu(1)">首页</span>
					<span class="menu-item" :class="curMenu === 2? 'active' : ''" @click="changeMenu(2)">公司简介</span>
					<span class="menu-item" :class="curMenu === 3? 'active' : ''" @click="changeMenu(3)">产品中心</span>
					<span class="menu-item" :class="curMenu === 4? 'active' : ''" @click="changeMenu(4)">联系我们</span>
				</div>
			</div>
			<img class="contact-method" src="../assets/cyxy/img_information.png" alt="">
		</div>
		<div class="filing">
			<span>创羽心研(苏州)技术有限公司 版权所有</span>
			<span>备案号：</span>
			<a class="number" target="_blank" href="https://beian.miit.gov.cn/">苏ICP备2023002220号</a>
		</div>
	</div>
  </div>
</template>

<script>
export default {
	name: 'index',
	data() {
		return {
			curMenu: 1,
			curProduct: 0,
			title: '创羽心研',
		}
	},
	mounted() {
		window.addEventListener('scroll', (e) => {
			if (window.pageYOffset < 400) {
				this.curMenu = 1
			} else if (document.documentElement.clientHeight + window.pageYOffset + 10 >= document.documentElement.offsetHeight) {
				this.curMenu = 4
			}
		})
	},
	methods: {
		changeMenu(index) {
			this.curMenu = index
			const arr = ['','#company-profile-container', '#product-list','#contact-us-container']
			window.location.href = arr[index - 1]
		},
		changeCurProduct(index) {
			this.curProduct = index
			window.location.href = '#product-list-' + index
		}
	}
}
</script>

<style lang="scss" scoped>
.header-banner-container {
	display: flex;
	flex-direction: column;
	width: 100vw;
	height: 888px;
	background: linear-gradient(107.56deg, #1CA5E4 0%, #65CEB8 100%);
	.header-container {
		display: flex;
		align-items: center;
		flex-grow: 0;
		width: 100vw;
		height: 98px;
		padding-top: 32px;
		padding-left: 260px;
		padding-right: 260px;
		box-sizing: border-box;
		.left {
			display: flex;
			align-items: center;
			img {
				width: 235px;
				height: 60px;
			}
		}
		.menus {
			display: flex;
			align-items: center;
			margin-left: 357px;
			.menu-item {
				margin-right: 120px;
				font-weight: 400;
				font-size: 18px;
				line-height: 28px;
				color: #F0ECE9;
				cursor: pointer;
			}
			.active {
				font-weight: 500;
				color: #FFFFFF;
			}
		}
		
	}
	.banner-container {
		flex-grow: 1;
		display: flex;
		justify-content: center;
		padding-left: 260px;
		padding-right: 260px;
		padding-top: 113px;
		box-sizing: border-box;
		.title {
			margin-top: 82px;
			font-weight: 600;
			font-size: 60px;
			line-height: 90px;
			color: #FFFFFF;
		}
		.desc {
			margin-top: 40px;
			font-weight: 400;
			font-size: 20px;
			line-height: 30px;
			color: #fff;
		}
		.banner-icon {
			width: 515px;
			height: 520px;
			margin-right: 40px;
			margin-left: 125px;
		}
	}
}

.more-btn {
	width: 260px;
	height: 80px;
	margin-top: 52px;
	line-height: 80px;
	font-weight: 500;
	font-size: 24px;
	text-align: center;
	color: #0A2B33;
	background: linear-gradient(90deg, #32FFC3 0%, #3BFBC3 100%);
	border-radius: 40px;
}
.company-profile-container {
	padding: 120px 260px;
	.flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.left {
		img {
			width: 60px;
			height: 60px;
		}
		.title {
			margin-top: 32px;
			font-weight: 600;
			font-size: 42px;
			line-height: 63px;
			color: #0A2B33;
		}
		.desc {
			margin-top: 24px;
			font-weight: 400;
			font-size: 18px;
			line-height: 28px;
			color: #545F64;
		}
		.more-about {
			margin-top: 80px;
			font-weight: 500;
			font-size: 18px;
			line-height: 28px;
			color: #1CA5E3;
		}
	}
	.company-pic {
		width: 620px;
		height: 480px;
		margin-top: 80px;
		margin-right: 80px;
	}
	.container-title {
		font-weight: 500;
		font-size: 32px;
		line-height: 48px;
		color: #0A2B33;
	}
	.idea-list {
		display: flex;
		margin-top: 40px;
		margin-left: -40px;
		&-item {
			flex-grow: 0;
			width: 320px;
			height: 143px;
			padding: 2px;
			box-sizing: border-box;
			box-sizing: border-box;
			margin-left: 40px;
			font-size: 20px;
			// border: 2px solid;
			background: linear-gradient(to right, #1CA5E3, #63CDB8);
			border-radius: 8px;
			.white-block {
				width: 100%;
				height: 100%;
				padding: 32px;
				box-sizing: border-box;
				background: white;
				border-radius: 8px;
				.label {
					background: linear-gradient(90deg, #1DA5E3 0%, #63CDB8 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
					background-clip: text;
					text-fill-color: transparent;
				}
			}
			.desc {
				margin-top: 16px;
				font-weight: 400;
				font-size: 18px;
				line-height: 27px;
				color: #545F64;
			}
			&:last-child {
				flex-grow: 1;
			}
		}
	}
}
.product-list {
	padding-top: 145px;
	box-sizing: border-box;
	background: #F7F9FA;
	&-title {
		margin-left: 260px;
		font-weight: 600;
		font-size: 42px;
		line-height: 63px;
		color: #0A2B33;
	}
	&-menu {
		display: flex;
		align-items: center;
		justify-content: space-evenly;
		width: calc(100% - 520px);
		height: 88px;
		margin-left: 260px;
		margin-bottom: 20px;
		margin-top: 40px;
		background: #FFFFFF;
		box-shadow: 0px 8px 24px rgba(142, 164, 174, 0.08);
		border-radius: 16px;
		font-weight: 400;
		font-size: 20px;
		line-height: 30px;
		color: #545F64;
		.item {
			height: 88px;
			line-height: 88px;
			cursor: pointer;
			img {
				width: 40px;
				height: 40px;
				margin-right: 12px;
				vertical-align: middle;
			}
		}
		.active {
			border-bottom: 2px solid #37FFC4;
		}
	}
	.flex {
		display: flex;
		position: relative;
		align-items: center;
		justify-content: space-between;
		.icon {
			// position: relative;
			// right: -260px;
			width: 1200px;
			height: 770px;
		}
		.icon-left {
			// position: relative;
			// left: -260px;
			// top: 0;
			width: 1200px;
			height: 770px;
			// z-index: 1;
		}
		.left, .right {
			width: 40%;
			z-index: 2;
			position: relative;
			left: 260px;
			width: 30%;
			.title {
				margin-top: 32px;
				font-weight: 500;
				font-size: 40px;
				line-height: 60px;
				color: #0A2B33;
			}
			.desc {
				margin-top: 32px;
				font-weight: 400;
				font-size: 18px;
				line-height: 28px;
				color: #545F64;
			}
		}
		.right {
			position: relative;
			left: -200px;
			width: 30%;
		}
	}
	.line {
		// width: calc(100% - 520px);
		// margin-left: 260px;
		// height: 0px;
		// border-bottom: 1px dashed #9CE2CD;
		width: calc(100% - 520px);
		margin-left: 260px;
		height: 1px;
		background-image: linear-gradient(to right, #9CE2CD 35%, rgba(255,255,255,0) 0%); /* 35%设置虚线点x轴上的长度 */
		background-position: bottom; /* top配置上边框位置的虚线 */
		background-size: 10px 1px; /* 第一个参数设置虚线点的间距；第二个参数设置虚线点y轴上的长度 */
		background-repeat: repeat-x;
	}
}
.contact-us-container {
	padding: 60px 260px 32px 260px;
	box-sizing: border-box;
	background: #484E4E;
	.flex {
		display: flex;
		justify-content: space-between;
		
		.menus {
			margin-top: 36px;
			.menu-item {
				margin-right: 40px;
				font-weight: 400;
				font-size: 18px;
				line-height: 28px;
				color: #C3C6CB;
				cursor: pointer;
			}
			.active {
				font-weight: 500;
				color: #FFFFFF;
			}
		}
		.icon {
			width: 235px;
			height: 60px;
		}
		.contact-method {
			width: 325px;
			height: 102px;
		}
	}
	.filing {
		margin-top: 53px;
		padding-top: 24px;
		font-weight: 400;
		font-size: 14px;
		text-align: center;
		line-height: 22px;
		color: #B6BEBF;;
		border-top: 1px solid #5A5E6C;
		.number {
			text-decoration: none;
			color: #a9a9a9;
		}
	}
}
</style>
